export default "__VITE_ASSET__Cv9cAfs___"